import PricingContainer from "../../../../Components/Applications/ECommerce/Pricing/PricingContainer";

const Pricing = () => {
  return <PricingContainer />;
};

export default Pricing;
